import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import Category from "../../utilities/data/model/Category";
import { TextPropTypes, Text } from "@towersystems/roam-common-native";

const UNKNOWN_CATEGORY = "Unknown Category";

export type CategoryIdToNameProps = TextPropTypes & {
  categoryId: string;
};

export const CategoryIdToName = ({
  categoryId,
  ...props
}: CategoryIdToNameProps) => {
  const [name, setName] = React.useState<string | undefined>(undefined);
  const database = useDatabase();

  React.useEffect(() => {
    (async () => {
      try {
        const category = await database
          .get<Category>("categories")
          .find(categoryId);

        setName(category.name ?? UNKNOWN_CATEGORY);
      } catch (err) {
        setName(UNKNOWN_CATEGORY);
      }
    })();
  }, [categoryId]);

  if (!name) {
    return null;
  }

  return <Text {...props}>{name}</Text>;
};
